import { useNavigate } from 'react-router-dom';

type NavigateFunction = ReturnType<typeof useNavigate>;
type NavigateToEvent = CustomEvent<{ pathname: string; search: string }>;

type navigateMessagePayload = {
  pathname: string;
  search: string;
};

export const navigateTo = (f: NavigateFunction, e: Event) => {
  if ((e as NavigateToEvent).detail) {
    const event = e as NavigateToEvent;

    if (typeof event.detail.pathname === 'number') {
      f(event.detail.pathname);
      return;
    }

    f({
      pathname: event.detail.pathname,
      search: event.detail.search,
    });
    return;
  }

  if ((e as unknown as navigateMessagePayload).pathname) {
    const event = e as unknown as navigateMessagePayload;

    if (typeof event.pathname === 'number') {
      f(event.pathname);
      return;
    }

    f({
      pathname: event.pathname,
      search: event.search,
    });
  }
};
